export const enum LocalStorageKeys {
  CALL_CHECKED_DATETIME = 'callCheckedDatetime',
  BLE_AUTO_SENDING = 'bleAutoSending',
  SCHEDULE_DRAFT = 'scheduleDraft',
  SCHEDULE_EDITING_DRAFT = 'scheduleEditingDraft',
  SCHEDULE_COMMENT_DRAFT = 'scheduleCommentDraft'
}
